<template>
  <div v-if="loader">
    <img
      src="../../../../assets/img/loader.svg"
      alt="loader"
      class="sa-loader sa-loader-top"
    />
  </div>
  <div v-else>
    <div class="sa-mob-cont">
      <button class="sa-btn-back"  @click="$parent.vaccinPop = false">
        <i class="icon-arrow-left"></i>
      </button>
      <h6 class="sa-card-tit sa-ref-tit">Vaccination</h6>
      <div class="sa-h-sm-up">
        <div class="sa-form-group">
          <input
            type="text"
            class="sa-form-control sa-search-lft"
            id="searchName"
            name="Search Name"
            placeholder="Search"
          />
          <i class="icon-search sa-search-icn"></i>
        </div>
      </div>
      <ul class="sa-nurse-list">
        <li v-for="(vacc, i) in vaccList" :key="i">
          <input
            type="checkbox"
            :id="vacc.tsk_id"
            :name="vacc.tsk_nm"
            :value="vacc.tsk_id"
            v-model="selected"
          />
          <label :for="vacc.tsk_id">
            <figure class="sa-avtar sa-avtar-lg">
              <img
                :src="vacc.tsk_img"
                alt="Doctor"
                class="sa-img-cover"
              />
            </figure>
            <span class="sa-nurse-cnt"
              ><strong>{{vacc.tsk_nm}}</strong
              ><small class="sa-d-block"
                >{{Array.prototype.map.call(vacc.inclsn, function(item) { return item; }).join(",")}}</small
              ></span
            >
          </label>
        </li>
      </ul>
    </div>
    <div class="sa-ftr-btn">
      <button :disabled="selected && selected.length <= 0" class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs" @click="refervaccin()">
        Continue
      </button>
    </div>
  </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
export default {
  props: ["vaccin"],
  methods: {
     refervaccin () {
        this.loader = true
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))
        _self.$store.dispatch('httpPost', {
            uri: `${pro_url}/refer/addTreatmentReferal`,
            body:{
            "apnt_id": _self.patDetails.apnt_id,
            // "pid": _self.patDetails.pid,
            "uid": _self.patDetails.refDoctor || "",
            stid: _self.patDetails.stid || '',
            dept_id: _self.patDetails.dept_id || '',
            "pkg_id": _self.patDetails.refPackages || [],
            "tsk_id": _self.patDetails.refNurse,
            "tst_id": _self.patDetails.refTests || [],
            "trtmnt_id": _self.patDetails.refPhysio || [],
            'radiology':  _self.patDetails.radiology || [],
            "hemodialysis": _self.patDetails.hemodialysis || [],
            "vitamin_iv_drip": _self.patDetails.vitamin_iv_drip || [],
            "covid": _self.patDetails.covid || [],
            "vaccination": _self.selected,
            ref_doctorId : _self.patDetails.ref_doctorId || ''
            }
        }).then(response => {

            _self.loading = false
            if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Referred vaccination Tasks successfully",
                class: "sa-a-success"
            });
            this.$parent.vaccinPop = false
            this.$parent.getReferralData();
            } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: `${response.desc}. Something went wrong. Please try again or contact operations team`,
                class: "sa-a-danger"
            });
            }
        })      
    }
  },
  data() {
    return {
      searchName:'',
      vaccList:[],
      selected:[],
      loader: false
    };
  },
  mounted() {
     this.selected = (this.vaccin && this.vaccin.length )? this.vaccin: []
        let _self = this
         _self.loader = true;
        _self.$store.dispatch("httpPost", {
            uri: `${pro_url}/refer/treatmentDetails`,
            body: {
                "mtype": 8,  
                "limit": 1000,
                "page": 1,
                "name": _self.searchName,
                "prd_id":'ST033'
            }
            }).then(response => {
            if (response && response.status === 1000) {
              console.log(response,'responseresponseresponseresponse')
               _self.loader = false;
                _self.vaccList = response.data.data 
                console.log(_self.vaccList);
            }
        })
  }
};
</script>